import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#1D252D'}
        d="M172.309-100.001q-30.308 0-51.308-21t-21-51.308v-375.382q0-30.308 21-51.308t51.308-21h80v-240h289.997v152.308H312.307V-400H400v-219.999h387.691q30.308 0 51.308 21t21 51.308v375.382q0 30.308-21 51.308t-51.308 21H172.309z"
      ></path>
    </svg>
  );
}

export default Icon;
